import { render, staticRenderFns } from "./childOrder.vue?vue&type=template&id=572448a7&scoped=true"
import script from "./childOrder.vue?vue&type=script&lang=js"
export * from "./childOrder.vue?vue&type=script&lang=js"
import style0 from "./childOrder.vue?vue&type=style&index=0&id=572448a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572448a7",
  null
  
)

export default component.exports